// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import ErrorStore from 'stores/ErrorStore'
import ErrorActions from 'actions/ErrorActions'
import { withToastManager } from 'ui/toast';

class ErrorAlert extends React.Component {
  constructor () {
    super();
    this.state = {
      error: ErrorStore.getError()
    };

    this._onChange = this._onChange.bind(this);
    this.onDefaultErrorDismiss = this.onDefaultErrorDismiss.bind(this);
  }

  onDefaultErrorDismiss (e) {
    ErrorActions.clearError();
    if ( e.stopPropagation )
      e.stopPropagation();
  }

  // component did update
  componentDidUpdate (_, prevState) {
    // if previous error message does not equal new error message or is new
    const newError = this.state.error || {};
    const prevError = prevState.error || {};
    if ( !!newError.message && newError.message !== prevError.message ) {
      // show toast
      this.props.toastManager.add(
        newError.message, {
         appearance: this.state.error.status === 'SEVERE' ? 'error' : 'warning',
         autoDismiss: false,
         onDismiss: this.onDefaultErrorDismiss
       });      
    }
  }

  _onChange()
  {
    this.setState({
      error: ErrorStore.getError()
    })
  }

  componentDidMount () {
    ErrorStore.addChangeListener(this._onChange);
  }

  componentWillUnmount () {
    ErrorStore.removeChangeListener(this._onChange);
  }

  render () {
    // Only render toast notifications via componentDidUpdate
    // No visual rendering needed since toasts handle display
    return <div></div>;
  }
}

export default withToastManager(ErrorAlert);
